import { useEffect, useState } from "react";

function Counter({ end, duration = 2000 }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 16);

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [end, duration]);

  return <span>{count}+</span>;
}

export default function Stats() {
  return (
    <section
      className="relative py-20 text-white reveal"
      style={{
        backgroundImage:
          "url('/images/slide1.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed", // ✅ Parallax
      }}
    >
      {/* OVERLAY */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* CONTENT */}
      <div className="relative max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold mb-12">
          From Farm to Global Market
        </h2>

        <div className="grid md:grid-cols-3 gap-8">

          {/* STAT 1 */}
          <div className="bg-white/10 backdrop-blur-md p-8 rounded-xl shadow-lg hover:scale-105 transition">
            <h3 className="text-4xl font-bold text-green-400">
              <Counter end={10} />
            </h3>
            <p className="mt-2 text-sm">Years Experience</p>
          </div>

          {/* STAT 2 */}
          <div className="bg-white/10 backdrop-blur-md p-8 rounded-xl shadow-lg hover:scale-105 transition">
            <h3 className="text-4xl font-bold text-green-400">
              <Counter end={50} />
            </h3>
            <p className="mt-2 text-sm">Countries Served</p>
          </div>

          {/* STAT 3 */}
          <div className="bg-white/10 backdrop-blur-md p-8 rounded-xl shadow-lg hover:scale-105 transition">
            <h3 className="text-4xl font-bold text-green-400">
              <Counter end={100} />
            </h3>
            <p className="mt-2 text-sm">Products Exported</p>
          </div>

        </div>
      </div>
    </section>
  );
}